import React, { useEffect } from 'react';
import useGlobal from 'hooks/useGlobal';
import { useQuery } from '@apollo/react-hooks';
import { getCheckoutEmail, getCheckoutShippingOnly } from '@/queries/getCart';
import getCheckoutIdQuery from '@/queries/getCheckoutId';
import OrderSummary from './order-summary';
import Shipping from './shipping';
import Payment from './payment';

function loadScript(callback) {
  const hasScript = document.querySelector('#payment-script');
  const cb = () => null;
  const myScript = document.createElement('script');
  myScript.id = 'payment-script';
  myScript.src = process.env.GATSBY_SQUARE_SCRIPT_REF;
  myScript.onload = callback || cb;
  if (hasScript) return null;
  return document.head.appendChild(myScript);
}

export default function PageCart() {
  const { state, emit } = useGlobal();
  const { data: checkoutId } = useQuery(getCheckoutIdQuery);
  const id = checkoutId?.checkout?.checkoutId;
  const resEmail = useQuery(getCheckoutEmail, {
    variables: {
      id
    }
  });
  const resShipping = useQuery(getCheckoutShippingOnly, {
    variables: {
      id
    },
    fetchPolicy: 'network-only'
  });
  const { step, edit } = state?.checkout || {};
  const customerInfo = {
    email: edit !== 'contact' && resEmail?.data?.node?.email,
    shippingAddress:
      edit !== 'address' && resShipping?.data?.node?.shippingAddress?.formatted,
    shippingLine:
      edit !== 'shipping' &&
      edit !== 'address' &&
      resShipping?.data?.node?.shippingLine
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [step]);

  useEffect(() => {
    loadScript(() => {
      emit.update({
        formReady: true
      });
    });
  }, []);
  // return <OrderSummary />;
  switch (step) {
    case 'shipping':
      return <Shipping customerInfo={customerInfo} />;
    case 'payment':
      return <Payment customerInfo={customerInfo} />;
    default:
      return <OrderSummary />;
  }
}
